// removed by extract-text-webpack-plugin
module.exports = {"container":"MKaUfy7wGnTNl7fX5KnNC"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Home/Layout/styles.css
// module id = 1642
// module chunks = 85